import { useState, useEffect, useCallback } from "react";

export function useLocalState(key, initial) {
  const [val, setVal] = useState(() => {
    try {
      const raw = localStorage.getItem("itp_" + key);
      if (raw) return JSON.parse(raw);
    } catch (e) {}
    return typeof initial === "function" ? initial() : initial;
  });
  useEffect(() => {
    try { localStorage.setItem("itp_" + key, JSON.stringify(val)); } catch (e) {}
  }, [key, val]);
  return [val, setVal];
}

export const uid = (p = "id") => p + "_" + Math.random().toString(36).slice(2, 9);

export function getUser() {
  try { return JSON.parse(localStorage.getItem("itp_user")); } catch (e) { return null; }
}
export function setUser(u) {
  if (u) localStorage.setItem("itp_user", JSON.stringify(u));
  else localStorage.removeItem("itp_user");
}
export const getToken = () => localStorage.getItem("itp_token");
export function setSession({ token, user }) {
  ["itp_studio_song", "itp_art_doc"].forEach((k) => localStorage.removeItem(k));
  localStorage.setItem("itp_token", token);
  setUser(user);
}
export function clearSession() {
  ["itp_token", "itp_user", "itp_studio_song", "itp_art_doc"].forEach((k) => localStorage.removeItem(k));
}

export const fmtMoney = (n) => "$" + Number(n || 0).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 });

export const fmtDur = (sec) => {
  sec = Math.max(0, Math.round(sec || 0));
  const h = Math.floor(sec / 3600), m = Math.floor((sec % 3600) / 60), s = sec % 60;
  return (h ? h + ":" + String(m).padStart(2, "0") : m) + ":" + String(s).padStart(2, "0");
};

export const parseDur = (str) => {
  if (!str) return 0;
  const p = String(str).split(":").map(Number);
  if (p.some(isNaN)) return 0;
  return p.reduce((a, b) => a * 60 + b, 0);
};

export function useInterval(cb, ms) {
  const saved = useCallback(cb, [cb]);
  useEffect(() => {
    if (ms == null) return;
    const id = setInterval(saved, ms);
    return () => clearInterval(id);
  }, [saved, ms]);
}
